import { AxiosResponse } from 'axios';
import { backendApiInstance } from './backendApiInstance';

export async function getProducts(): Promise<AxiosResponse> {
  return backendApiInstance.get('subscriptions');
}

export async function getProductById(productId: string): Promise<AxiosResponse> {
  return backendApiInstance.get(`subscriptions/${productId}`);
}
